<template>
  <div>
    <footer class="footer">
      <div class="clearfix"></div>
      <div class="icon-row">
        <div class="footer-icon">
          <h5 class="footer-icon-child"></h5>
          <span class="footer-icon-text">品类齐全，轻松购物</span>
        </div>
        <div class="footer-icon">
          <h5 class="footer-icon-child footer-icon-child-2"></h5>
          <span class="footer-icon-text">多仓直发，极速配送</span>
        </div>
        <div class="footer-icon">
          <h5 class="footer-icon-child footer-icon-child-3"></h5>
          <span class="footer-icon-text">正品行货，精致服务</span>
        </div>
        <div class="footer-icon">
          <h5 class="footer-icon-child footer-icon-child-4"></h5>
          <span class="footer-icon-text">天天低价，畅选无忧</span>
        </div>
      </div>
      <div class="service-intro">
        <div class="servece-type">
          <div
            class="servece-type-info"
            v-for="(guide, index) in guideArr"
            :key="index"
          >
            <ul>
              <li
                @click="goNewPage(item.id)"
                v-for="(item, index) in guide"
                :key="index"
              >
                {{ item.title }}
              </li>
            </ul>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="friend-link">
          <div class="friend-link-item">
            <ul>
              <li v-for="(link, index) in moreLink" :key="index">
                <span
                  @click="goMoreLink(link.url)"
                  :class="[linkItemClass, { 'link-last-item': index === 9 }]"
                  >{{ link.title }}</span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      linkItemClass: "link-item",
      // 对照代码27行,若需要添加href需要重新修改代码逻辑
      guideArr: [
        [
          { id: 0, title: "新手上路" },
          { id: 1, title: "如何搜索" },
          // { id: 2, title: "忘记密码" }
        ],
        [
          { id: 0, title: "帮助中心" },
          { id: 3, title: "如何发货" },
          { id: 4, title: "联系卖家" },
          { id: 5, title: "会员修改密码" },
          { id: 6, title: "常见问题" },
          { id: 7, title: "修改收货地址" }
        ],
        [
          { id: 0, title: "支付方式" },
          { id: 8, title: "在线支付" },
          { id: 9, title: "分期付款" },
          { id: 10, title: "公司转账" }
        ],
        [
          { id: 0, title: "售后服务" },
          { id: 11, title: "退换货政策" },
          { id: 12, title: "退换货流程" },
          { id: 13, title: "退款说明" }
        ],
        [
          { id: 0, title: "客服中心" },
          { id: 14, title: "商城商品推荐" }
        ],
        [
          { id: 0, title: "特色服务" },
          { id: 15, title: "积分细则" },
          { id: 16, title: "积分兑换说明" }
        ],
        [
          { id: 0, title: "关于我们" },
          { id: 17, title: "合作及洽谈" },
          { id: 18, title: "招聘英才" },
          { id: 19, title: "联系我们" }
        ]
      ],
      // 对照代码36行,若需要添加href需要重新修改代码逻辑
      moreLink: [
        { title: "关于我们", url: "#" },
        { title: "联系我们", url: "#" },
        { title: "联系客服", url: "#" },
        { title: "合作招商", url: "#" },
        { title: "商家帮助", url: "#" },
        { title: "营销中心", url: "#" },
        { title: "销售联盟", url: "#" },
        { title: "校园社区", url: "#" },
        { title: "风险监测", url: "#" },
        { title: "隐私政策", url: "/helper/privacy" }
      ]
    };
  },
  methods: {
    goNewPage(id) {
      if (id != 0) {
        let routeUrl = this.$router.resolve({
          path: "/Help/" + id
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    goMoreLink(url) {
      let routeUrl = this.$router.resolve({
        path: url
      });
      if (url === "#") {
        window.open(routeUrl.href, "_self");
      } else {
        window.open(routeUrl.href, "_blank");
      }
    }
  }
};
</script>

<style scoped>
/*****************************底 部 开 始*****************************/
.footer {
  width: 100%;
  height: 390px;
  padding-top: 30px;
  background-color: #eaeaea;
}
.icon-row {
  margin: 15px auto;
  padding-top: 8px;
  width: 1000px;
  height: 64px;
}
.footer-icon {
  margin-left: 17px;
  margin-right: 17px;
  float: left;
}
.footer-icon-child {
  margin-top: 10px;
  overflow: hidden;
  position: absolute;
  width: 36px;
  height: 42px;
  background-image: url("../../../static/img/footer/ico_service.png");
  text-indent: -999px;
}
.footer-icon-child-2 {
  background-position: 0 -43px;
}
.footer-icon-child-3 {
  background-position: 0 -86px;
}
.footer-icon-child-4 {
  background-position: 0 -129px;
}
.footer-icon-text {
  margin-left: 45px;
  color: #444444;
  font-size: 18px;
  font-weight: bold;
  line-height: 64px;
}
.service-intro {
  width: 100%;
  border-top: 1px solid #b2dfdb;
}
.servece-type {
  margin: 15px auto;
  height: 200px;
  width: 800px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.servece-type-info {
  color: #666666;
}
.servece-type-info ul {
  list-style: none;
}
.servece-type-info li {
  font-size: 14px;
  cursor: pointer;
  line-height: 26px;
}
.servece-type-info li:first-child {
  font-size: 16px;
  line-height: 28px;
  font-weight: bold;
}
.friend-link {
  display: flex;
  align-items: center;
  width: 908px;
  height: 30px;
  margin: 0px auto;
  color: #666;
  border-top: 1px solid #b2dfdb;
}
.friend-link-item {
  margin: 0px auto;
}
.friend-link-item ul {
  list-style: none;
}
.friend-link-item li {
  padding: 5px 0px;
  float: left;
}
.link-item {
  padding: 0px 8px;
  cursor: pointer;
  border-right: 1px solid #ccc;
}
.link-last-item {
  border: none;
}
.copyright {
  width: 100%;
  color: #666;
  line-height: 30px;
  text-align: center;
}
.copyright a {
  color: #232323;
  font-size: 20px;
}
/*****************************底 部 结 束*****************************/
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue